import React from "react";
import { Invoice } from "../../common/types/invoice";
import { Pagination } from "../general/Pagination/Pagination";
import { InvoicesTable } from "./InvoicesTable";
import { PaginatedInvoicesTableContext } from "./PaginatedInvoicesTableContextProvider";

interface InvoicesTableContainerProps {
    onInvoiceClick: (invoice: Invoice) => void;
    selectedInvoiceId?: string;
}

export const InvoicesTableContainer: React.FC<InvoicesTableContainerProps> = ({
    onInvoiceClick,
    selectedInvoiceId,
}) => {
    const {
        invoices,
        invoiceCount,
        currentSort,
        handleSortChange,
        currentPage,
        totalPages,
        setPage,
        isLoading,
    } = React.useContext(PaginatedInvoicesTableContext);

    return (
        <InvoicesTable
            invoices={invoices ?? []}
            invoiceCount={invoiceCount}
            onInvoiceClick={onInvoiceClick}
            sort={currentSort}
            onSortChange={handleSortChange}
            selectedInvoiceId={selectedInvoiceId}
            pagination={
                <Pagination
                    pageCount={totalPages}
                    currentPage={currentPage}
                    onPageChange={setPage}
                />
            }
            isLoading={isLoading}
        />
    );
};
